(() => {
  const init = (root) => {
    if (root.dataset.reviewsBound === 'true') return;
    root.dataset.reviewsBound = 'true';

    const photos = [...root.querySelectorAll('[data-review-photo]')];
    const entries = [...root.querySelectorAll('[data-review-entry]')];
    const prevBtn = root.querySelector('[data-review-prev]');
    const nextBtn = root.querySelector('[data-review-next]');
    const count = photos.length;
    if (count === 0) return;

    const autoplay = root.dataset.autoplay === 'true';
    let index = 0;
    let timer = null;

    const layoutFor = (photoIndex, activeIndex) => {
      const offset = (photoIndex - activeIndex + count) % count;
      if (offset === 0) {
        return { zIndex: 3, opacity: 1, pointerEvents: 'auto', transform: 'translateX(0) translateY(0) scale(1) rotateY(0deg)' };
      }
      if (offset === 1) {
        return { zIndex: 2, opacity: count > 2 ? 1 : 0, pointerEvents: count > 2 ? 'auto' : 'none', transform: 'translateX(30%) translateY(6%) scale(0.86) rotateY(-14deg)' };
      }
      if (offset === count - 1) {
        return { zIndex: 2, opacity: count > 2 ? 1 : 0, pointerEvents: count > 2 ? 'auto' : 'none', transform: 'translateX(-30%) translateY(6%) scale(0.86) rotateY(14deg)' };
      }
      return { zIndex: 1, opacity: 0, pointerEvents: 'none', transform: 'translateX(0) scale(0.8)' };
    };

    const render = () => {
      photos.forEach((el, i) => {
        const style = layoutFor(i, index);
        el.style.transition = 'transform 700ms var(--ease-out, ease), opacity 700ms var(--ease-out, ease)';
        el.style.zIndex = style.zIndex;
        el.style.opacity = style.opacity;
        el.style.pointerEvents = style.pointerEvents;
        el.style.transform = style.transform;
      });

      entries.forEach((el, i) => {
        el.hidden = i !== index;
        el.classList.remove('is-revealed');
      });

      const activeEntry = entries[index];
      if (activeEntry) {
        // Force reflow so the class re-triggers the CSS transition on repeat views.
        void activeEntry.offsetWidth;
        requestAnimationFrame(() => activeEntry.classList.add('is-revealed'));
      }
    };

    const restartAutoplay = () => {
      if (!autoplay || count < 2) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), 5000);
    };

    const go = (nextIndex) => {
      index = ((nextIndex % count) + count) % count;
      render();
      restartAutoplay();
    };

    prevBtn?.addEventListener('click', () => go(index - 1));
    nextBtn?.addEventListener('click', () => go(index + 1));

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') go(index - 1);
      if (event.key === 'ArrowRight') go(index + 1);
    });

    render();
    restartAutoplay();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-reviews-carousel]').forEach(init);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('wowthings:content:load', (event) => initAll(event.target));
  initAll();
})();
